<template>
  <div id="privacy-policy">
    <v-container>
      <v-row>
        <v-col>
          <Privacy />
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import Privacy from "@/privacyPolicy/de.md";

export default {
  components: {
    Privacy,
  },
};
</script>
